import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import selectn from "selectn";
import classNames from "classnames";

import CardWrapper from "cards/components/CardWrapper";
import Microdata from "cards/components/Microdata";
import SplitLayout from "components/Library/Layout/components/SplitLayout";
import BylinePhoto from "cards/components/BylinePhoto";
import Byline from "cards/components/Byline";
import PubDate from "cards/components/PubDate";
import SaveButton from "cards/components/SaveButton";
import TextOverHeadline from "cards/components/TextOverHeadline";
import Headline from "cards/components/Headline";
import PrimaryImage from "cards/components/PrimaryImage";
import StoryBody from "components/Library/StoryBody";
import TagLink from "cards/components/TagLink";
import ShareLinks from "cards/components/ShareLinks";

import { toggleStorySave } from "users/actions/userSettings";
import { FACTS_MATTER_TEMPLATE } from "config/constants";
import styles from "./FullStoryCard.css";
import FULL_STORY_CARD_FRAGMENT from "./FullStoryCard.graphql";

class FullStoryCard extends React.Component {

  static fragments = { content: FULL_STORY_CARD_FRAGMENT }

  constructor() {
    super();

    this.state = { saved: false };

    this.toggleStorySave = this._toggleStorySave.bind(this);
  }

  static getDerivedStateFromProps(props) {
    return { saved: props.savedStories.includes(props.story.id) };
  }

  _toggleStorySave() {
    this.props.toggleStorySave(this.props.story.id, this.state.saved);
  }

  render() {
    const { story, isFeatured, index } = this.props;

    return (
      <CardWrapper
        className={classNames({
          [styles.factsMatter]: story.template === FACTS_MATTER_TEMPLATE,
          [styles.featured]: isFeatured && !selectn("rubric.name", story) && story.template !== FACTS_MATTER_TEMPLATE,
        })}
      >
        <Microdata story={story} />
        <SplitLayout
          left={
            <React.Fragment>
              <BylinePhoto photoSrc={story.byline_photo} />
              <Byline authors={story.authors} />
              <PubDate story={story} />
            </React.Fragment>
          }
          right={
            <SaveButton
              saved={this.state.saved}
              onClick={this.toggleStorySave}
            />}
          className={styles.header}
        />
        <TextOverHeadline rubric={story.rubric} isFeatured={isFeatured} />
        <Headline headline={story.headline} />
        <PrimaryImage image={story.primary_image} lazyload={!!index} />
        <StoryBody story={story} renderMicrodata={true} />
        <SplitLayout
          left={
            <TagLink tag={story.primary_tag} />
          }
          right={
            <ShareLinks headline={story.headline} permalink={story.permalink} />
          }
          leftClassName={styles.tagButton}
        />
      </CardWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    savedStories: state.userSettings.data.profileInfo.savedStoryIds,
  };
};

const mapDispatchToProps = {
  toggleStorySave,
};

FullStoryCard.propTypes = {
  story: PropTypes.object.isRequired,
  isFeatured: PropTypes.bool,
  savedStories: PropTypes.array.isRequired,
  toggleStorySave: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(FullStoryCard);
